import React, { useCallback, useState } from 'react';
import TM from 'ts-translate-js';
import { findPackageTickets, findPackageTicketsAtPinPoint, findTickets, findTicketsAtPinPoint } from '../../../mvcapi/buy-ticket-api';
import { FindTicketsAtPintpointResult, FindTicketsResultCommon } from '../../../mvcapi/models/buyticket/findticketsresult';
import { useAddTicketsToCartStore } from '../../../stores';
import { TicketQtySelector } from '../selecttickets/ticket-qty-selector';
import { PleaseWaitSpinner } from '../../../../jsxctl/utilctl';
import './ticket-search-wizard.scss';
import { useAddPackageToCartStoreExt } from '../../../stores/add-to-cart-stores/add-package-to-cart-store-ext';
import { useVenuePlanControl } from '../../../logic/hooks/use-venue-plan-control';

const tr = TM.boundTR;

// INFO: New sale
export function TicketSearchWizard() {
    const eventDate = useAddTicketsToCartStore(s => s.eventDate);
    const selectedSection = useAddTicketsToCartStore(s => s.selectedSection);
    const ticketSearchPoint = useAddTicketsToCartStore(s => s.ticketSearchPoint);
    const [ticketQuantity, setTicketQuantity] = useState(eventDate.SuggestedQtySales || eventDate.InternetTicketQTYMultipleOf || 1);

    const [searchingTicket, setSearchingTicket ] = useAddTicketsToCartStore(s => [s.searchingTicket, s.setSearchingTicket]);
    const setShowTicketSearchWizard = useAddTicketsToCartStore(s => s.setShowTicketSearchWizard);
    const planControl = useVenuePlanControl();

    const addNewTickets = useAddTicketsToCartStore(s => s.addNewTickets);
    const addNewPackageTickets = useAddPackageToCartStoreExt(s => s.addNewTickets);
    const [ isAPackageSale, packageId, selectedPackageEventDateIds ] = useAddPackageToCartStoreExt(s => [ s.isAPackageSale, s.packageId, s.selectedEventDateIds ]);

    const setSearchTicketErrorMessage = useAddTicketsToCartStore(s => s.setSearchTicketErrorMessage);

    const handleOnCloseWizard = useCallback(() => {
        setShowTicketSearchWizard(false);
    }, [setShowTicketSearchWizard]);

    const handleOnChangeTicketQty = useCallback((newQty: number) => {
        setTicketQuantity(newQty);
    }, [setTicketQuantity]);

    const handleFindTickets = useCallback(async () => {
        setSearchingTicket(true);
        setSearchTicketErrorMessage("");
        if(ticketSearchPoint) {
            let result: FindTicketsAtPintpointResult;
            if(isAPackageSale())
                result = await findPackageTicketsAtPinPoint(packageId, eventDate.EventDateID, selectedPackageEventDateIds, ticketQuantity, ticketSearchPoint, false);
            else
                result = await findTicketsAtPinPoint(eventDate.EventDateID, ticketQuantity, ticketSearchPoint, false);

        
            if(result.isSuccess) {
                if(isAPackageSale())
                    await addNewPackageTickets(result.tickets);
                else
                    await addNewTickets(result.tickets);

                if(result.tickets.length > 0)
                    planControl.moveToXYZoomAtLeast({ x: result.tickets[0].Position.X, y: result.tickets[0].Position.Y }, 1, 1000); // In case of a package, Ticket [0] should be in our base event.

                setSearchingTicket(false);
            } else {
                let message = result.message != "" ? result.message : tr("Erreur lors de la recherche de billets à cet endroit.");
                setSearchTicketErrorMessage(message);
                setSearchingTicket(false);
                handleOnCloseWizard();
            }

        } else if(selectedSection) {
            let result: FindTicketsResultCommon;
            if(isAPackageSale())
                result = await findPackageTickets(packageId, selectedPackageEventDateIds, ticketQuantity, [ selectedSection.Name ], false);
            else
                result = await findTickets(eventDate.EventDateID, ticketQuantity, selectedSection.ID, undefined, false); 


            if(result.isSuccess) {
                if(isAPackageSale())
                    await addNewPackageTickets(result.foundTickets);
                else
                    await addNewTickets(result.foundTickets);

                // General admission, we move to the first ticket found which will probably be the position on the center of the GA section.
                if(result.foundTickets.length > 0 && result.foundTickets[0].Position)
                    planControl.moveToXYZoomAtLeast({ x: result.foundTickets[0].Position.X, y: result.foundTickets[0].Position.Y }, 1, 1000); // In case of a package, Ticket [0] should be in our base event.

                setSearchingTicket(false);
            } else {
                setSearchTicketErrorMessage(result.message);
                setSearchingTicket(false);
                handleOnCloseWizard();
            }
        }
    }, [setSearchingTicket, setSearchTicketErrorMessage, ticketSearchPoint, selectedSection, isAPackageSale, packageId, eventDate.EventDateID, selectedPackageEventDateIds, ticketQuantity, addNewPackageTickets, addNewTickets, planControl, handleOnCloseWizard]);


    return <div key="ticketQty" className="ticket-search-wizard">
        <div className="qty-selector">
            <div style={{minWidth: "250px"}}><strong>{tr("Combien de billets désirez-vous?")}</strong></div>
            <TicketQtySelector
                maxQty={10}
                limitQtySales={eventDate.LimitQtySales}
                suggestedQtySales={eventDate.SuggestedQtySales}
                internetTicketQTYMultipleOf={eventDate.InternetTicketQTYMultipleOf}
                defaultValue={ticketQuantity}
                onQtyChange={handleOnChangeTicketQty}
            />
        </div>
        <div className='action-button'>
            {searchingTicket ? <PleaseWaitSpinner /> :
                <>
                    <button className="btn btn-primary" onClick={handleFindTickets}>{tr("Chercher")}</button>
                    <button className="btn btn-default" onClick={handleOnCloseWizard}>{tr("Annuler")}</button>
                </>
            }
        </div>
    </div>;
}

